import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var PackageSearch = function PackageSearch(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M20.5 7.2778 12 12.0001m0 0L3.5 7.2778m8.5 4.7223v9.5m9-9.5V7.9415c0-.3426 0-.514-.0505-.6667a1 1 0 0 0-.2141-.364c-.1091-.1183-.2588-.2015-.5584-.368l-7.4-4.111c-.2836-.1576-.4254-.2364-.5755-.2673a1 1 0 0 0-.4029 0c-.1502.031-.292.1097-.5756.2673l-7.4 4.111c-.2995.1665-.4493.2497-.5584.368a1 1 0 0 0-.2141.364C3 7.4276 3 7.5988 3 7.9415v8.1171c0 .3427 0 .514.0505.6668a1 1 0 0 0 .2141.3639c.109.1184.2589.2016.5584.368l7.4 4.1111c.2836.1576.4254.2363.5756.2672a1 1 0 0 0 .4029 0c.1501-.0309.2919-.1096.5755-.2672l.223-.1239M7.5 4.5001l9 5m5.5 12-1-1m1-2.5c0 1.6568-1.3431 3-3 3s-3-1.3432-3-3 1.3431-3 3-3 3 1.3431 3 3"
    })
  }));
};
export default PackageSearch;